import api from './api';

class PasoProcesoConciliadorService {

  getItems(id, cadenaBusqueda) {
    cadenaBusqueda = cadenaBusqueda ? cadenaBusqueda : ''
    return api.get(`/api/procesos_conciliador/${id}/pasos_proceso_conciliador${cadenaBusqueda}`);
  }

  newItem(id, params) {
    return api.post(`/api/procesos_conciliador/${id}/pasos_proceso_conciliador`, params)
  }

  editItem(id, params) {
    return api.put(`/api/procesos_conciliador/${id}/pasos_proceso_conciliador/${params.id}`, params)
  }

  deleteItem(procesoId, id) {
    return api.delete(`/api/procesos_conciliador/${procesoId}/pasos_proceso_conciliador/${id}`)
  }
}

export default new PasoProcesoConciliadorService();
